<p-toast></p-toast>
<div class="ml-5 md:px-5 md:ml-0" *ngIf="filters.length === 0">
    {{'no_filters_saved' | translate}}
</div>
<div class="ml-5 md:px-5 md:ml-0" *ngFor="let filter of filters">
    <div class="mb-3 p-2 w-full shadow-1 border-round">
        <div class="flex flex-row justify-content-between">
            <div class="flex w-full justify-content-between">
                <div class="flex flex-column w-3">
                    <h5 class="my-1 mr-2">
                        {{'categories' |translate}}
                    </h5>
                    <div  *ngIf="filter.filter_categories !== undefined">
                        {{getCategoriesName(filter.filter_categories)}}
                    </div>
                    <div  *ngIf="filter.filter_categories === undefined">
                        {{'category_all' | translate}}
                    </div>
                </div>
                <div class="flex flex-column w-3 pl-3">
                    <h5 class="my-1 mr-2">
                        {{'price_range' |translate}}
                    </h5>
                    <div>
                        {{'from' | translate}} {{getMinPrice(filter.filter_min_price)}}{{'currency_unit' | translate}} {{'to' | translate}} {{getMaxPrice(filter.filter_max_price) == 500 ? ('over' | translate) :''}} {{getMaxPrice(filter.filter_max_price)}}{{'currency_unit'  | translate}}
                    </div>
                </div>
                <div class="flex flex-column w-3 pl-3">
                    <h5 class="my-1 mr-2">
                        {{'discount' |translate}}
                    </h5>
                    <div *ngIf="filter.filter_min_saving !== undefined">
                        > {{filter.filter_min_saving}} %
                    </div>
                    <div *ngIf="filter.filter_min_saving === undefined">
                        {{'all' |  translate}}
                    </div>
                </div>
                <div class="flex flex-column w-3">
                    <h5 *ngIf="filter.filter_available_only === true">
                        {{'only_available_deals' |translate}}
                    </h5>
                    <h5 *ngIf="filter.filter_available_only !== true">
                        {{'include_expired_deals' |translate}}
                    </h5>
                </div>
            </div>
            <div class="flex flex-row">
                <div class="flex flex-column">
                    <h5 class="my-1 mr-2">
                        {{'notification_active' |translate}}
                    </h5>
                    <div class="mx-auto mt-2">
                        <p-inputSwitch (onChange)="changeNotificationStatus($event, filter)" class="align-self-center" [(ngModel)]="filter.notification_active"></p-inputSwitch>
                    </div>
                </div>
                <div>
                    <h5 class="my-1 mr-2">
                        {{'delete' |translate}}
                    </h5>
                    <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-dlnd-dark m-auto" (click)="deleteFilter(filter)"></button>
                </div>
            </div>
        </div>
    </div>
</div>
<p-confirmDialog [style]="{width: '50vw'}"
                 [baseZIndex]="10000"
                 acceptButtonStyleClass="p-button-dlnd-dark"
                 rejectButtonStyleClass="p-button-dlnd"></p-confirmDialog>
